import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import MetaTags from "../../element/MetaTags";
import Menu from "./components/menu";

const bg = require("../../../images/servicehero.png");

class SpringCleaning extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Spring Cleaning"
          description="Spring Cleaning"
          keywords="Spring Cleaning"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr  bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Spring Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className=" col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic3.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Stress Less and Breathe Easier with the Help of a
                              Professional Spring Cleaning Service in Gold
                              Coast, Queensland
                            </Link>
                          </h4>
                          <p>
                            Spring itself reminds us of renewal. Who wouldn't
                            love to feel the same renewal within one's house to
                            create a spotless, stress-free house to start the
                            summer? However, as the name suggests, spring
                            cleaning involves a complete cleaning that can be
                            time-consuming, leaving you one reason to opt for a
                            professional service.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Why is Spring Cleaning Important?
                            </Link>
                          </h4>
                          <p>
                            Spring cleaning claims to offer a variety of health
                            benefits apart from delivering you a clean
                            environment. According to the British Journal of
                            Sports Medicine research, cleaning can reduce stress
                            by 20%. A clean space directly affects our minds.
                            The cleaner it is, the healthier it is for our mind
                            and body. It is proven that less clutter in our
                            premises aids the brain in processing well.
                            Professional spring cleaners maintain a spring
                            cleaning checklist commencing with all the rooms and
                            clean every corner.
                          </p>

                          <p>
                            For instance, this includes an utter cleaning of:
                          </p>
                          <ul className="list-checked black">
                            <li>Window tracts</li>
                            <li>Dusting fans and light fixtures</li>
                            <li>Dusting room corners</li>
                            <li>
                              Disinfect door knobs, handles, and light switches
                            </li>
                            <li>Wipe down kitchen appliances</li>
                            <li>Clean the sink and refrigerator shelves</li>
                            <li>Sanitize office equipment</li>
                            <li>
                              Cleaning of the outdoors, living room, bathrooms,
                              bedrooms, and laundry rooms
                            </li>
                          </ul>
                          <p>
                            Henceforth, it is convenient to maintain a spring
                            cleaning checklist to spark efficient results!
                            Regardless of how crucial spring cleaning is, harsh
                            chemicals can destroy that importance quickly.
                            Professional spring cleaning companies further focus
                            on health consciousness and environmental
                            sustainability. We at Kangaroo Shine Property
                            Services in Gold Coast use eco-friendly products to
                            bring you the best in spring, cleaning your space.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="dlab-box"></div>
                    <div className="dlab-info m-t30">
                      <h4 className="dlab-title m-t0">
                        <Link to="#">
                          Calming and Positive Energy for Your Mental Health
                        </Link>
                      </h4>
                      <p>
                        It is evident in psychology that springtime corresponds
                        with increased energy. People are spending more time
                        outside since the days are longer and warmer and because
                        they are getting more sun exposure.
                      </p>
                      <p>
                        It is why maintaining the aesthetics of our homes links
                        with mental health. Cleaning and organizing our
                        surroundings helps us cope with our daily stress. Spring
                        cleaning possesses mental health benefits to help you
                        achieve a calm environment full of positive energy.
                      </p>
                      <p>
                        Spring cleaning supplies an emotional benefit; it lends
                        a sense of control over one's surroundings.
                        Incorporating cleaning as a part of your daily routine
                        further contributes to a healthy lifestyle. If you are a
                        health-conscious person, then this is your call! We all
                        love walking into a clean, neatly organized room after a
                        stressful day. Feeling an invigorating energy around us
                        always feels relaxing after an exhausting day.
                      </p>
                      <p>
                        These emotions have the power to impact our mental
                        health and affect our confidence. For example, clutter,
                        on the other hand, can be the total contrary. It makes
                        you lose focus and creates emotions of distraught. It is
                        why you should include spring cleaning in your to-do
                        list!
                      </p>
                      <p>
                        However, most of us are trapped in our hectic schedules,
                        and it is fair to understand that not all can manage the
                        stress of spring cleaning their house. While there are
                        several tips, it can be challenging depending on the
                        lifestyle. Our team of experts at Kangaroo Shine
                        Property Services in Gold Coast is there to help you
                        welcome spring or summer with a new home. We can help
                        you with various cleaning services, including spring
                        cleaning in Gold Coast. Call us today at +61424888804 to
                        discuss further options!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default SpringCleaning;
